// extracted by mini-css-extract-plugin
export default {"button":"StyleSecondarySmallFalse1_button__uDKwp","stylesecondarySmallfalse":"StyleSecondarySmallFalse1_stylesecondarySmallfalse__QfEZ2"};